import type { ComponentProps, FC } from "react";

import { Switch } from "../../components";
import { cn } from "../../utils";
import { FieldBase, type FieldBaseProps } from "./field-base";
import { useField } from "./use-field";

export type FieldSwitchProps = FieldBaseProps & {
  onChange?: ComponentProps<typeof Switch>["onCheckedChange"];
  onBlur?: ComponentProps<typeof Switch>["onBlur"];
  inputProps?: ComponentProps<typeof Switch>;
};

export const FieldSwitch: FC<FieldSwitchProps> = ({ inputProps, onChange, onBlur, ...props }) => {
  const { field, hasError } = useField({ name: props.name, disabled: props.disabled, inputProps });

  const handleChange: FieldSwitchProps["onChange"] = (checked) => {
    field.onChange(checked);
    onChange?.(checked);
  };

  const handleBlur: FieldSwitchProps["onBlur"] = (event) => {
    field.onBlur();
    onBlur?.(event);
  };

  return (
    <FieldBase labelOrientation="horizontal" labelPosition="end" {...props}>
      <Switch
        {...field}
        {...inputProps}
        checked={field.value}
        onCheckedChange={handleChange}
        onBlur={handleBlur}
        className={cn(
          {
            "border border-destructive": hasError && !field.disabled,
          },
          inputProps?.className
        )}
      />
    </FieldBase>
  );
};
